export const environment = {
  production: false,
  apiUrl: 'https://api-dev.myhotel.io/integrations',
  security_url: 'https://api-dev.myhotel.io/security',
  apiKey: 'Upy1BTFzD63LFLzlkeCy72gFJokPrUGC4ZLUtbIq',
  apiKeyFid: 'O0rZnFWuKDaktLXLfw3L28Tya9hPlcto778HZdXC',
  fidelityUrl: 'https://api-dev.myhotel.io/',
  theme: 'dev',
};
